import React from 'react';
import HomeLayout from '../../../components/Layout/HomeLayout';
import Content from '../../components/Pages/auth/DualAuthCheck';

function DualAuthCheckInfoTrac() {
  document.title = 'InfoTrac: Dual Auth Check';

  return (
    <HomeLayout containerClassName="h-screen">
      <Content />
    </HomeLayout>
  );
}

export default DualAuthCheckInfoTrac;
